import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import type { Props as ButtonProps } from '@sorare/core/src/atoms/buttons/Button';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import '@sorare/core/src/atoms/buttons/ButtonsList';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconHelpCircle } from '@sorare/core/src/atoms/icons/system/iconHelpCircle.ts';
import { LinkOther } from '@sorare/core/src/atoms/navigation/Box';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import { wheel } from '@sorare/core/src/lib/glossary';

import { HowToWinTicketDialog } from '#src/components/Wheel/HowToWinTicketDialog/index.tsx';

type Props = {
  variant?: 'icon' | 'button';
} & ButtonProps;
export const HowToWinTicketsButton = ({
  variant: variantProp,
  onClick,
  ...rest
}: Props) => {
  const isTabletAndAbove = useIsTabletAndAbove();
  const variant = variantProp || (isTabletAndAbove ? 'button' : 'icon');
  const [open, setOpen] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setOpen(true);
    onClick?.(e);
  };
  return (
    <>
      {variant === 'button' && (
        <LinkOther
          as={Button}
          {...rest}
          startIcon={<FontAwesomeIcon icon={iconHelpCircle} />}
          onClick={handleClick}
        >
          <FormattedMessage {...wheel.howToWin} />
        </LinkOther>
      )}
      {variant === 'icon' && (
        <IconButton {...rest} onClick={handleClick} icon={iconHelpCircle} />
      )}
      <HowToWinTicketDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};
